var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kangfu_button"},_vm._l((_vm.list),function(item){return _c('div',{key:item,staticClass:"kangfu_button_item",class:item === _vm.val ? 'select_item':'',on:{"click":function($event){return _vm.onClick(item)}}},[_c('div',{staticClass:"content"},[_vm._v(_vm._s(item))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }